var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSappchatLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.3283 0H8.24069C3.69487 0 0.00976562 3.68511 0.00976562 8.23092V41.8179C0.00976562 46.3637 3.69487 50.0488 8.24069 50.0488H42.3283C46.8742 50.0488 50.5593 46.3637 50.5593 41.8179V8.23092C50.5593 3.68511 46.8742 0 42.3283 0Z",
    fill: "url(#paint0_linear_65_20)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4443 16.1716C32.3034 16.1716 33.8105 14.6794 33.8105 12.8387C33.8105 10.998 32.3034 9.50586 30.4443 9.50586C28.5852 9.50586 27.0781 10.998 27.0781 12.8387C27.0781 14.6794 28.5852 16.1716 30.4443 16.1716Z",
    fill: "#063552"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3916 9.51074C20.3916 9.51074 13.6809 11.4614 13.6809 18.5919C13.6809 18.5919 12.969 23.4494 19.459 26.0174L19.6852 26.1049C26.4125 28.6511 28.7745 29.5854 28.9014 32.5578C29.0283 35.5302 27.4003 38.6283 21.9976 37.6503C21.9976 37.6503 18.0959 37.612 12.9083 26.5748C12.9083 26.5748 11.6225 34.6177 16.3796 40.2839C16.3796 40.2839 16.9314 38.7157 19.7239 39.0108C22.5163 39.3058 29.6574 40.497 33.4046 38.5026C35.4337 37.424 36.975 35.6245 37.7183 33.4663C38.4617 31.3081 38.3519 28.9512 37.4112 26.8698C37.4112 26.8698 36.4675 23.8974 31.0647 21.8593C25.6619 19.8213 21.3795 18.0346 21.3795 18.0346C21.3795 18.0346 15.629 15.4938 20.3916 9.51074Z",
    fill: "#063552"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_65_20",
    x1: 25.2845,
    y1: 0,
    x2: 25.2845,
    y2: 50.0488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BABABA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSappchatLogo);
export default __webpack_public_path__ + "static/media/sappchat-logo.0ae3f94d4d730a14853cddfc7f4234d1.svg";
export { ForwardRef as ReactComponent };